import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { jsx as e, jsxs as o, Fragment as t } from "react/jsx-runtime";
import { Component as i, cloneElement as n } from "react";
import { calculateRem as r, withVDSManager as a, generateUUID as s, checkIfMobileDevice as l, getBrowser as d, getOS as c } from "@vds-core/utilities";
import { ButtonIcon as p } from "@vds-core/button-icons";
import { ColorTokens as h } from "@vds-tokens/color";
import { ComponentTokens as u } from "@vds-tokens/component";
import v from "@vds-core/icons/info";
import f from "styled-components";
import m from "./TooltipDialog.js";
import g from "./TooltipPopover.js";
function b(e, o, t) {
  if (t) return h.interactive.disabled["on".concat(o)].value;
  return "primary" === e || "secondary" === e || "brandHighlight" === e ? "brandHighlight" === e ? h.elements.brandhighlight.value : h.elements[e]["on".concat(o)].value : e;
}
function D(e, o) {
  return "secondary" === e ? "light" === o ? u.tooltip.icon.active.secondary.onlight.value : u.tooltip.icon.active.secondary.ondark.value : h.interactive.active["on".concat(o)].value;
}
var w = f.span.withConfig({
    displayName: "TooltipWrapper",
    componentId: "VDS__sc-yvzd18-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  padding: 0;\n  outline: none;\n  ", ";\n  pointer-events: auto;\n  &:hover {\n    z-index: 1;\n  }\n"])), function (_ref) {
    var e = _ref.disabled;
    return e && "\n    pointer-events: none;\n    cursor: default;\n  ";
  }),
  y = f.span.withConfig({
    displayName: "TooltipIconWrapper",
    componentId: "VDS__sc-yvzd18-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  outline: none;\n"]))),
  k = f.span.withConfig({
    displayName: "CustomAnchorElementWrapper",
    componentId: "VDS__sc-yvzd18-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n"]))),
  x = f.span.withConfig({
    displayName: "HoverZone",
    componentId: "VDS__sc-yvzd18-3"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 14rem;\n  left: calc(50% + 2px);\n  height: 2.75rem;\n  top: 50%;\n  z-index: -1;\n  transform: translate(-50%, -50%);\n  display: ", ";\n"])), function (_ref2) {
    var e = _ref2.showDialog;
    return e ? "inline-block" : "none";
  }),
  I = f.span.withConfig({
    displayName: "ScreenReaderText",
    componentId: "VDS__sc-yvzd18-4"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"]))),
  E = f.span.withConfig({
    displayName: "AnchorIconWrapper",
    componentId: "VDS__sc-yvzd18-5"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  background: none;\n  color: inherit;\n  cursor: ", ";\n  transition-delay: 0.2s;\n  overflow: visible;\n  left: ", ";\n  position: relative;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  -webkit-tap-highlight-color: transparent;\n  button {\n    ", "\n\n    ", "\n\n    ", "\n\n  ", "\n  }\n\n  button:focus:not(:hover)::before {\n    width: calc(100%);\n    height: calc(100%);\n  }\n\n  button:active svg path {\n    fill: ", ";\n  }\n"])), function (_ref3) {
    var e = _ref3.disabled;
    return e ? "default" : "pointer";
  }, r(4), function (_ref4) {
    var e = _ref4.surface,
      o = _ref4.disabled;
    return "light" === e && "&:hover {\n        box-shadow: ".concat(o ? "none" : "0 0 0 0.188rem ".concat(u.tooltip.container.hover.onlight.value), ";\n      }");
  }, function (_ref5) {
    var e = _ref5.surface,
      o = _ref5.disabled;
    return "light" === e && "&:hover:active {\n        box-shadow: ".concat(o ? "none" : "0 0 0 0.188rem ".concat(u.tooltip.container.hover.onlight.value), ";\n      }");
  }, function (_ref6) {
    var e = _ref6.surface,
      o = _ref6.disabled;
    return "dark" === e && "&:hover {\n      box-shadow: ".concat(o ? "none" : "0 0 0 0.188rem ".concat(u.tooltip.container.hover.ondark.value), ";\n    }");
  }, function (_ref7) {
    var e = _ref7.surface,
      o = _ref7.disabled;
    return "dark" === e && "&:hover:active {\n      box-shadow: ".concat(o ? "none" : "0 0 0 0.188rem ".concat(u.tooltip.container.hover.ondark.value), ";\n    }");
  }, function (_ref8) {
    var e = _ref8.$iconActiveColor,
      o = _ref8.disabled;
    return !o && e;
  });
var A = /*#__PURE__*/function (_i) {
  _inherits(A, _i);
  function A(i) {
    var _this;
    _classCallCheck(this, A);
    var r;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(A).call(this, i)), r = _assertThisInitialized(_assertThisInitialized(_this)), _this.scrollbarId = s(), _this.setHasScrollableContent = function (e) {
      r.setState({
        hasScrollableContent: e
      });
    }, _this._resize = function () {
      r.setAnchorElementPositionProperties(), r.isMobileDevice = l();
    }, _this._onKeyDown = function (e) {
      var o, t;
      var i = r.state.showDialog,
        n = e.keyCode,
        a = 32 === n,
        s = 13 === n,
        l = 27 === n,
        d = 9 === n,
        c = e.shiftKey;
      a && e.preventDefault(), s || a || l && i ? r.setState({
        showDialog: !i
      }) : (c && d || d) && i && r.closeDialog(e), null !== r.anchorWithRef && (null === (o = r.anchorElementProps) || void 0 === o ? void 0 : o.props.onKeyDown) && r.anchorElementProps.props.onKeyDown(e), null !== r.anchorWithRef && (null === (t = r.anchorElementProps) || void 0 === t ? void 0 : t.props.onBlur) && r.anchorElementProps.props.onBlur(e);
    }, _this.closeDialog = function (e) {
      r.isMobileDevice ? (e.stopPropagation(), r.setState({
        unmounted: !0
      }), r.unMountTimer = setTimeout(function () {
        r.setState({
          showDialog: !1,
          unmounted: !1
        });
      }, 100)) : r.setState({
        showDialog: !1,
        unmounted: !0
      });
    }, _this.openDialog = function () {
      r.setState({
        showDialog: !0,
        unmounted: !1
      });
    }, _this.setAnchorElementPositionProperties = function () {
      var e;
      var o = null === (e = r.toolTipAnchorRef) || void 0 === e ? void 0 : e.getBoundingClientRect();
      r.setState({
        tooltipAnchorCoordinates: o
      });
    }, _this._onClickOutside = function (e) {
      var _r = r,
        o = _r.toolTipAnchorRef;
      o && !o.contains(e.target) && e.target && "HTML" !== e.target.tagName && e.target.getAttribute("data-tooltip") !== r.ariaId && e.target.parentNode && e.target.parentNode.getAttribute("data-tooltip") !== r.ariaId && e.target.parentNode.id !== r.ariaId && e.target.parentNode.id !== "scrollbar-view-".concat(r.scrollbarId) && e.target.id !== "scrollbar-view-".concat(r.scrollbarId) && r.setState({
        keyboardFocused: !1,
        clicked: !1,
        showDialog: !1,
        hovered: !1
      });
    }, _this._onMouseEnter = function (e) {
      var o;
      if (!r.isMobileDevice && e.target.parentNode.id !== "scrollbar-view-".concat(r.scrollbarId)) {
        var _t = r.state.keyboardFocused;
        _t && r.setState({
          keyboardFocused: !1
        }), r.openTooltipTimeout = setTimeout(function () {
          r.setState({
            showDialog: !0,
            unmounted: !1,
            hovered: !0
          });
        }, 200), null !== r.anchorWithRef && (null === (o = r.anchorElementProps) || void 0 === o ? void 0 : o.props.onMouseEnter) && r.anchorElementProps.props.onMouseEnter(e);
      }
    }, _this._onMouseExit = function (e) {
      var o;
      if (r.isMobileDevice) return;
      var _r$state = r.state,
        t = _r$state.clicked,
        i = _r$state.showDialog;
      t && i || (clearTimeout(r.openTooltipTimeout), r.setState({
        hovered: !1,
        showDialog: !1,
        keyboardFocused: !1
      }), null !== r.anchorWithRef && (null === (o = r.anchorElementProps) || void 0 === o ? void 0 : o.props.onMouseLeave) && r.anchorElementProps.props.onMouseLeave(e));
    }, _this._onClick = function (e) {
      var o, t;
      e.stopPropagation(), e.preventDefault();
      var _r$state2 = r.state,
        i = _r$state2.clicked,
        n = _r$state2.hovered,
        a = _r$state2.showDialog;
      null === (t = (o = r.props).onClick) || void 0 === t || t.call(o, e);
      var s = "undefined" != typeof document && document.getElementById("".concat(r.tooltipId, "-dialog"));
      n ? i ? r.setState({
        clicked: !1,
        showDialog: !1
      }) : r.setState({
        clicked: !0
      }) : s && s.contains(e.target) || (r.isMobileDevice && a ? (r.setState({
        unmounted: !0
      }), r.animationDelay = setTimeout(function () {
        r.setState({
          showDialog: !1,
          unmounted: !1
        });
      }, 100)) : r.setState({
        clicked: !1,
        showDialog: !a
      }));
    }, _this._onFocus = function (e) {
      e.stopPropagation(), e.preventDefault();
      var _r$state3 = r.state,
        o = _r$state3.hovered,
        t = _r$state3.keyboardFocused;
      o || t || r.setState({
        keyboardFocused: !0
      });
    }, _this.setAnchorElement = function () {
      var _r$props = r.props,
        e = _r$props.renderAnchorElement,
        o = _r$props.ariaLabel,
        t = r.state.showDialog;
      return e ? e({
        ariaExpanded: t,
        ariaLabel: o
      }) : null;
    }, _this._setDialogRef = function (e) {
      e && e.offsetHeight - 1 > 202 ? r.setState({
        scrollable: !0
      }) : r.setState({
        scrollable: !1
      });
    }, _this._dialogOnKeyDown = function (e, o) {
      if (13 === e.keyCode || 32 === e.keyCode || 27 === e.keyCode) {
        e.preventDefault(), e.stopPropagation(), r.setState({
          showDialog: o
        });
        r.toolTipAnchorRef.focus();
      }
    }, _this.renderTooltipPopover = function () {
      var _r$state4 = r.state,
        o = _r$state4.clicked,
        t = _r$state4.customAnchorPresent,
        i = _r$state4.isIe,
        n = _r$state4.tooltipAnchorCoordinates,
        a = _r$state4.showDialog,
        s = _r$state4.keyboardFocused,
        l = _r$state4.hasScrollableContent,
        _r$props2 = r.props,
        d = _r$props2.disabled,
        c = _r$props2.children,
        p = _r$props2.title,
        h = _r$props2.surface,
        u = _r$props2.size,
        v = _r$props2.containerId,
        f = _r$props2.scrollbarBorderRadius,
        m = _r$props2.tooltipBorderRadius,
        b = _r$props2.maxHeight,
        D = !!r.props.renderAnchorElement;
      return a && !d ? e(g, {
        "data-testid": "dialog",
        clicked: o,
        customAnchorElement: r.toolTipAnchorRef,
        customAnchorPresent: t,
        content: c,
        deactivateDialogState: r.closeDialog,
        title: p,
        ariaId: r.ariaId,
        tooltipId: r.tooltipId,
        keyboardFocused: s,
        keepDialogActiveOnMouseEnter: s ? null : r.openDialog,
        toolTipAnchorRef: r.toolTipAnchorRef,
        showDialog: a,
        surface: h,
        size: u,
        isIe: i,
        containerId: v,
        tooltipWrapperId: r.tooltipWrapperId,
        tooltipAnchorCoordinates: n,
        onPopoverKeyDown: r._dialogOnKeyDown,
        setRef: r._setDialogRef,
        setHasScrollableContent: r.setHasScrollableContent,
        hasScrollableContent: l,
        hasAnchorElement: D,
        isFirefox: r.isFirefox,
        handleTabKeyPress: r.closeDialog,
        scrollbarId: r.scrollbarId,
        scrollbarBorderRadius: f,
        tooltipBorderRadius: m,
        maxHeight: b
      }) : null;
    }, _this.renderMobileTooltipDialog = function () {
      var _r$state5 = r.state,
        o = _r$state5.showDialog,
        t = _r$state5.unmounted,
        _r$props3 = r.props,
        i = _r$props3.disabled,
        n = _r$props3.surface,
        a = _r$props3.children,
        s = _r$props3.closeButtonText;
      return o && !i ? e(m, Object.assign({}, r.props, {
        closeButtonText: s,
        dialogId: "".concat(r.tooltipId, "-dialog"),
        dialogOpened: o,
        surface: n,
        body: a,
        onClick: r.closeDialog,
        unmounted: t,
        isAndroidDevice: r.isAndroidDevice
      })) : null;
    }, _this.renderIconAnchorElement = function () {
      var _r$props4 = r.props,
        t = _r$props4.disabled,
        i = _r$props4.ariaLabel,
        n = _r$props4.size,
        a = _r$props4.surface,
        s = _r$props4.iconFillColor,
        l = _r$props4.tabIndex,
        d = _r$props4.renderTooltipDialog,
        c = _r$props4.fakeMobileDevice,
        h = _r$props4["data-track"],
        u = _r$props4["data-track-ignore"],
        f = _r$props4["data-clickstream"],
        m = _r$props4["data-analyticstrack"],
        _r$state6 = r.state,
        g = _r$state6.clicked,
        w = _r$state6.showDialog,
        k = _r$state6.hovered,
        A = _r$state6.isIe,
        C = _r$state6.hasScrollableContent,
        S = d && (r.isMobileDevice || c) ? r.renderMobileTooltipDialog() : r.renderTooltipPopover();
      return o(y, {
        tabIndex: r.isAndroidDevice ? void 0 : -1,
        $importantForAccessibility: "no",
        onMouseLeave: t ? void 0 : r._onMouseExit,
        onMouseEnter: t ? void 0 : r._onMouseEnter,
        children: [o(E, {
          $mobile: r.isMobileDevice,
          "data-testid": "tooltip",
          id: r.tooltipId,
          $showDialog: w,
          surface: a,
          $iconActiveColor: D(s, a),
          disabled: t,
          ref: function ref(e) {
            r.toolTipAnchorRef = e;
          },
          children: [A && e(I, {
            children: i
          }), r.isOsx && C && !w && e(I, {
            "aria-live": "assertive",
            children: "collapsed"
          }), e("span", {
            style: {
              outline: "none",
              display: "inline-flex"
            },
            children: e(p, {
              kind: "ghost",
              size: "small" === n ? "16px" : "20px",
              surface: a,
              tabIndex: l,
              surfaceType: "colorFill",
              disabled: t,
              focusBorderPosition: "outside",
              ariaLabel: i || "tooltip",
              iconOffset: {
                x: 0,
                y: 0
              },
              renderIcon: function renderIcon(o) {
                return e(v, Object.assign({}, o, {
                  color: b(s, a, t),
                  size: n
                }));
              },
              "aria-expanded": !(!r.isMobileDevice && void 0 === C) && (r.isMobileDevice && w ? void 0 : w),
              onClick: t ? void 0 : r._onClick,
              "data-track": h,
              "data-track-ignore": u,
              "data-clickstream": f,
              "data-analyticstrack": m
            })
          })]
        }), !r.isMobileDevice && e(x, {
          showDialog: r.state.showDialog,
          onClick: t ? void 0 : r._onClick
        }), e("span", {
          "aria-live": r.isMobileDevice ? void 0 : "assertive",
          "aria-relevant": "all",
          children: S
        })]
      });
    }, _this.renderCustomAnchorElement = function () {
      var i = r.setAnchorElement(),
        _r$props5 = r.props,
        a = _r$props5.disabled,
        s = _r$props5.tabIndex,
        l = _r$props5.ariaLabel,
        d = _r$props5.renderTooltipDialog,
        c = _r$props5.fakeMobileDevice,
        p = _r$props5["data-track"],
        h = _r$props5["data-track-ignore"],
        _r$state7 = r.state,
        u = _r$state7.clicked,
        v = _r$state7.showDialog,
        f = _r$state7.hovered,
        m = _r$state7.isIe,
        g = _r$state7.hasScrollableContent,
        b = d && (r.isMobileDevice || c) ? r.renderMobileTooltipDialog() : r.renderTooltipPopover();
      return o(t, {
        children: [o(k, {
          ref: function ref(e) {
            r.toolTipAnchorRef = e;
          },
          onMouseEnter: a ? void 0 : r._onMouseEnter,
          onMouseLeave: a ? void 0 : r._onMouseExit,
          onClick: a ? void 0 : r._onClick,
          onFocus: a ? void 0 : r._onFocus,
          children: [r.isOsx && g && !v && e(I, {
            "aria-live": "assertive",
            children: "collapsed"
          }), !r.isOsx && e(I, {
            "aria-live": "assertive",
            children: g && !m && "" + (v ? r.isFirefox ? "" : "expanded" : "collapsed")
          }), e("div", {
            tabIndex: -1,
            children: i && n(i, {
              onKeyDown: a ? void 0 : r._onKeyDown,
              id: r.tooltipId,
              disabled: a,
              tabIndex: s,
              "aria-expanded": v,
              "data-track": p,
              "data-track-ignore": h
            })
          })]
        }), e("span", {
          "aria-live": r.isMobileDevice ? void 0 : "assertive",
          "aria-relevant": "all",
          children: b
        })]
      });
    }, _this.state = {
      hovered: !1,
      keyboardFocused: !1,
      showDialog: !1,
      clicked: !1,
      customAnchorPresent: !1,
      isIe: "ie" === d(),
      tooltipAnchorCoordinates: {
        bottom: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        width: 0,
        x: 0,
        y: 0
      },
      hasScrollableContent: void 0,
      unmounted: void 0
    }, _this.ariaId = "tooltip-".concat(s()), _this.anchorWithRef = _this.setAnchorElement(), _this.anchorElementProps = _this.anchorWithRef, _this.isOsx = "osx" === c(), _this.isAndroidDevice = "android" === c(), _this.isFirefox = "firefox" === d();
    return _this;
  }
  _createClass(A, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._resize(), "undefined" != typeof window && (document.addEventListener("mousedown", this._onClickOutside), window.addEventListener("scroll", this.setAnchorElementPositionProperties), window.addEventListener("resize", this._resize)), this.props.renderAnchorElement && this.setState({
        customAnchorPresent: !0
      }), this.tooltipId = s(), this.tooltipWrapperId = this.props.id || "".concat(this.tooltipId, "-tooltipWrapper");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e, o) {
      var t;
      o.showDialog !== this.state.showDialog && this.state.keyboardFocused && (this.state.showDialog || this.setState({
        hasScrollableContent: void 0
      }), "undefined" != typeof document && (null === (t = document.getElementById(this.tooltipId)) || void 0 === t || t.focus()));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      "undefined" != typeof window && (this.isMobileDevice || document.removeEventListener("mousedown", this._onClickOutside), window.removeEventListener("scroll", this.setAnchorElementPositionProperties), window.removeEventListener("resize", this._resize));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        o = _this$props.className,
        t = _this$props.disabled;
      return e(w, {
        id: this.tooltipWrapperId,
        disabled: t || !1,
        className: o,
        tabIndex: this.isAndroidDevice ? void 0 : -1,
        children: this.props.renderAnchorElement ? this.renderCustomAnchorElement() : this.renderIconAnchorElement()
      });
    }
  }]);
  return A;
}(i);
A.defaultProps = {
  surface: "light",
  size: "medium",
  renderTooltipDialog: !0,
  title: null,
  ariaLabel: "More information",
  disabled: !1,
  fakeMobileDevice: !1,
  closeButtonText: "Close",
  tooltipBorderRadius: "4px",
  iconFillColor: "primary",
  scrollbarBorderRadius: "2px",
  maxHeight: 204
};
var C = a(A);
export { C as default };